///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { mode } from "./types";

export const isEffectiveCoyoteBid = summary => {
  if (summary?.isCoyoteBid === true) return true;
  return summary?.modes?.some(m => m.mode === mode.imdl) === true;
};
